export default __webpack_public_path__ + "static/media/dopes6.9bf32fec.jfif";